<template>
  <div>
    <p class="tw:caption tw:text-default-700 tw:p-3 tw:pb-0">{{ trans._menu.searchBar.recentSearch }}</p>

    <p
      v-for="(item, index) in recentSearch"
      :key="index"
      class="tw:p-3 tw:body-2 tw:text-black tw:block tw:hover:bg-default-000 tw:cursor-pointer tw:transition-all tw:duration-200 tw:ease-in-out"
      @click="handleOnRecentSearchClick(item)"
    >
      {{ item }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { sendCustomEventToGA } from "vue-app/plugins/edroneGtag";

interface Props {
  recentSearch: string[];
}

interface Emits {
  recentSearchClick: [item: string];
}

defineProps<Props>();
const emit = defineEmits<Emits>();

const handleOnRecentSearchClick = (item: string) => {
  emit("recentSearchClick", item);
  sendCustomEventToGA("search_bar_recent_search_click", {
    recent: item,
  });
};
</script>
